import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NsKey } from 'enums/NsKey';
import { User } from 'lucide-react';
import NoteManager from './NoteManager';

export interface InsuredOption {
  borrowerId: string;
  label: string;
}

interface NoteInsuredSelectorProps {
  insureds: Array<InsuredOption>;
}

export const NoteInsuredSelector: FC<NoteInsuredSelectorProps> = ({ insureds }) => {
  const { t } = useTranslation(NsKey.Note);
  const [selectedInsured, setSelectedInsured] = useState<InsuredOption | null>(null);

  // Once an insured is selected, show the NoteManager with their borrowerId as riskId
  if (selectedInsured) {
    return <NoteManager riskId={selectedInsured.borrowerId} autoOpenForm title={`Note de l'assuré - ${selectedInsured.label}`} />;
  }

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      <p className="text-lg font-semibold text-slate-700 mb-2">
        {t('INSURED_SELECTOR.TITLE')}
      </p>
      <p className="text-sm text-slate-500 mb-8">
        {t('INSURED_SELECTOR.DESCRIPTION')}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-lg">
        {insureds.map((insured) => (
          <button
            key={insured.borrowerId}
            onClick={() => setSelectedInsured(insured)}
            className="flex items-center gap-3 p-4 rounded-xl border border-slate-200 bg-white hover:border-primary hover:bg-primary/5 transition-all text-left group"
          >
            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary group-hover:bg-primary/20 transition-colors">
              <User size={18} />
            </span>
            <p className="text-sm font-semibold text-slate-800">
              {insured.label}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};
